import React from "react";
import {Trans, useTranslation} from "react-i18next";
import styled from "styled-components";
import {Body2, Body3, H1} from "pu-crossproduct-components/build/components/Atoms/Type/"
import {ExpansionPanel} from "pu-crossproduct-components/build/components/Molecules/DataDisplay/ExpansionPanel";
import {Icon} from "pu-crossproduct-components/build/components/Atoms/Icons/Icon";
import {Icons} from "pu-crossproduct-components/build/components/Molecules/Navigation/IconButton";
import {ITheme} from "pu-crossproduct-components/build/themes";
import {Link, LinkColors} from "pu-crossproduct-components/build/components/Molecules/Navigation/Link";
import {AccountCard} from "../../../03organisms/informat/AccountCard/AccountCard";
import {NotPerson} from "../../../03organisms/informat/NotPerson/NotPerson";


const CardHolder = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  max-width: 700px;

  & > * {
    margin: 12px 12px 12px 12px;
  }
`

interface Theme {
    theme: ITheme
}

const DisabledHolder = styled.div<Theme>`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  max-width: 710px;
  margin-top: 48px;
  background: white;
  ${props => props.theme.tokens.elevation.dp02};
`


export interface IAccount {
    accountLogin: string
    accountName: string
    isDisabled: boolean
    isLocked: boolean
    accountId: string
}

export interface InformatAccountPickerProps {
    userFirstName: string
    accounts: IAccount[]
    onClick: (account: IAccount) => void
}


const onLockedThenOnName = (a: IAccount, b: IAccount) => {

    const lockedSorter = (a: IAccount, b: IAccount) => (a.isLocked < b.isLocked)
        ? -1
        : (a.isLocked === b.isLocked)
            ? 0
            : 1;

    const nameSorter = (a: IAccount, b: IAccount) => (a.accountName.toUpperCase() < b.accountName.toUpperCase()) ? -1 : 1;
    return lockedSorter(a, b) || nameSorter(a, b);
}


export const InformatAccountPickerMultipleAccounts: React.FC<InformatAccountPickerProps> = props => {
    const {t} = useTranslation();
    const enabledAccounts = props.accounts.filter(a => a && !a.isDisabled).sort(onLockedThenOnName);
    const disabledAccounts = props.accounts.filter(a => a && a.isDisabled).sort(onLockedThenOnName);

    return <>
        <H1><Trans t={t} values={{userFirstName: props.userFirstName}}>twoFactorInformatAccountPickerTitle</Trans></H1>
        <Body2><Trans t={t}>twoFactorInformatAccountPickerDescription</Trans></Body2>

        <NotPerson userFirstName={props.userFirstName}/>

        <CardHolder>
            {enabledAccounts.map(account =>
                <AccountCard account={account} clickHandle={props.onClick}/>
            )}
        </CardHolder>

        {disabledAccounts.length === 0 ? undefined :
            <DisabledHolder>
                <ExpansionPanel header={<Trans t={t}>twoFactorInformatAccountPickerDisabledPanelTitle</Trans>}
                                headerLeadingElement={<Icon icon={Icons.users}/>}>
                    <CardHolder>
                        {disabledAccounts
                            .map(account =>
                                <AccountCard account={account} clickHandle={props.onClick}/>
                            )}
                    </CardHolder>
                </ExpansionPanel>
            </DisabledHolder>
        }
    </>

}
